// Fonte ÚNICA do ciclo de vida das Leads — usada em Leads Externas e Minha Pipeline.
// Mantém etiquetas, cores e ordem consistentes em todo o lado.

export const LEAD_STATUS_FLOW = [
  'nova',
  'em_contacto',
  'reagendada',
  'incontactavel',
  'proposta',
  'convertida',
  'sem_interesse',
  'invalida',
];

// Estados "ativos" (a trabalhar) vs "fechados" (terminais)
export const ACTIVE_LEAD_STATUSES = ['nova', 'em_contacto', 'reagendada', 'incontactavel', 'proposta'];
export const CLOSED_LEAD_STATUSES = ['convertida', 'sem_interesse', 'invalida'];

export const LEAD_STATUS_CONFIG = {
  nova: { label: 'Nova', color: 'bg-sky-100 text-sky-700', dot: 'bg-sky-500', column: 'border-t-sky-400' },
  em_contacto: { label: 'Em Contacto', color: 'bg-amber-100 text-amber-800', dot: 'bg-amber-500', column: 'border-t-amber-400' },
  reagendada: { label: 'Reagendada', color: 'bg-violet-100 text-violet-700', dot: 'bg-violet-500', column: 'border-t-violet-400' },
  incontactavel: { label: 'Incontactável', color: 'bg-orange-100 text-orange-800', dot: 'bg-orange-500', column: 'border-t-orange-400' },
  proposta: { label: 'Proposta', color: 'bg-blue-100 text-blue-700', dot: 'bg-blue-600', column: 'border-t-blue-500' },
  convertida: { label: 'Convertida', color: 'bg-emerald-600 text-white', dot: 'bg-emerald-600', column: 'border-t-emerald-500' },
  sem_interesse: { label: 'Sem Interesse', color: 'bg-slate-100 text-slate-600', dot: 'bg-slate-400', column: 'border-t-slate-400' },
  invalida: { label: 'Inválida', color: 'bg-red-100 text-red-700', dot: 'bg-red-500', column: 'border-t-red-400' },
};

export const leadStatusLabel = (status) => LEAD_STATUS_CONFIG[status]?.label || (status || '—');
export const leadStatusColor = (status) => LEAD_STATUS_CONFIG[status]?.color || 'bg-slate-100 text-slate-600';
export const isClosedLeadStatus = (status) => CLOSED_LEAD_STATUSES.includes(status);

// ===== Setor da Lead (Energia / Telecom / Alarmes) — derivado de service_interest =====
export const LEAD_SECTOR_CONFIG = {
  energia: { label: 'Energia', badge: 'bg-amber-100 text-amber-800' },
  telecom: { label: 'Telecom', badge: 'bg-blue-100 text-blue-700' },
  alarmes: { label: 'Alarmes', badge: 'bg-rose-100 text-rose-700' },
  outro: { label: 'Outro', badge: 'bg-slate-100 text-slate-600' },
};

// Normaliza o campo service_interest (valores baralhados: "Luz e Gas", "luz_gas", etc.)
export const leadSector = (serviceInterest) => {
  if (!serviceInterest) return null;
  const v = String(serviceInterest).toLowerCase();
  if (v.includes('telecom')) return 'telecom';
  if (v.includes('alarme')) return 'alarmes';
  if (v.includes('luz') || v.includes('gas') || v.includes('gás') || v.includes('solar') || v.includes('carregamento') || v.includes('energ')) return 'energia';
  return 'outro';
};
